import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';

import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

const getErrors = (draft) => {
    let errors = {};

    if (!draft.number && draft.number !== 0) {
        errors.number = "Required field";
    } else {
        const number = Number(draft.number);
        if (isNaN(number)) {
            errors.number = "Must be a number!";
        } else if ( 0 > number) {
            errors.number = "Cannot be negative!"
        }
    }

    if (!draft.textBody) {
        errors.textBody = "Required field";
    }

    if (!draft.unit) {
        errors.unit = "Required field";
    }

    if (!draft.templateId) {
        errors.templateId = "Required field";
    }
    return errors;
};

class ReminderDialog extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
        this.onRemove = this.onRemove.bind(this);
    }


    render() {
        const dialogProps = {
            title:          (!!this.state.draft.id ? 'Edit reminder' : 'Add reminder'),
            open:           true,
            modal:          true,
            onRequestClose: this.props.onClose,
            actions: [
                this.props.onRemove && <FlatButton key="remove" label="Remove" secondary={true} onTouchTap={this.onRemove} />,
                <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
                <FlatButton key="submit" label="Save" primary={true} onTouchTap={this.onSave} disabled={!this.state.isValid}/>
            ]
        };

        let templateSelect;
        if (this.props.templates.length > 0 && this.state.draft.type === 'email') {
            templateSelect = (
                    <SelectField
                    name="templateId"
                    floatingLabelText="Template"
                    value={this.state.draft.templateId}
                    onChange={this.onSelect.bind(this, 'templateId')}
                    errorText={this.state.errors.templateId}
                    fullWidth={true}
                    required
                >
                    {this.props.templates.map(t => <MenuItem key={t.id} value={t.id} primaryText={t.name} />)}
                </SelectField>
            );
        }

        return (
            <Dialog {...dialogProps} >
                <TextField
                    name="number"
                    floatingLabelText="Number"
                    value={this.state.draft.number}
                    onChange={this.onTextChange}
                    errorText={this.state.errors.number}
                    required
                />

                <SelectField
                    name="unit"
                    floatingLabelText="Unit"
                    value={this.state.draft.unit}
                    onChange={this.onSelect.bind(this, 'unit')}
                    errorText={this.state.errors.unit}
                    required
                >
                    {this.props.units.map((unit, index) => (<MenuItem key={index} value={unit} primaryText={unit} />))}
                </SelectField>

                {templateSelect}

                <TextField
                    name="textBody"
                    floatingLabelText="Text Body"
                    value={this.state.draft.textBody}
                    onChange={this.onTextChange}
                    errorText={this.state.errors.textBody}
                    fullWidth={true}
                    multiLine={true}
                    required
                />
            </Dialog>
        );
    }

    onTextChange({target}) {
        if (!target.name) { return; } //guard
        DialogActions.updateDraft(target.name, target.value);
    }

    onSelect(field, {target}, index, value) {
        DialogActions.updateDraft(field, value);
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }

    onRemove() {
        const removed = this.props.onRemove(this.state.draft);
        if (removed !== false) { this.props.onClose(); }
    }


}

ReminderDialog.getStores = () => ([DialogStore]);
ReminderDialog.calculateState = (prevState) => {
    const draft = DialogStore.getDraft();
    const errors = getErrors(draft);

    return {
        draft,
        errors,
        isValid: (Object.keys(errors).length === 0)
    };
};

ReminderDialog.propTypes = {
    units:          PropTypes.arrayOf(PropTypes.string),
    templates:      PropTypes.arrayOf(PropTypes.object),
    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool
};

ReminderDialog.defaultProps = {
    units:          ['minutes', 'hours', 'days'],
    // types:          ['email', 'notification'],
    templates:      [],
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(ReminderDialog);
